import React from 'react';
import ModelCard from '../../ModelCard';
import CardShimmer from '../../CardShimmer';
import ScrollListener from '../../ScrollListener';
import LoadMore from '../../../base/LoadMore';
import InnerMore from '../../InnerMore';
import { applyModel } from '../../../../helpers';
import { EmptyState } from '../../../base/modelLib/EmptyState';
import useScrollHandler from '../L2Wrapper/scrollHandler';
import { Divider } from '@mantine/core';
import { translate } from '@shakkerai/util-i18n';
import { innerMoreType, modalType } from '../../../../constants';
import FlowCard from '../../FlowCard';

const L3Wrapper = (props) => {
  const { cols, modelType, ratio, menuPath } = props;
  let target = (menuPath.menu.children ?? []).find((child) => (child.children ?? []).find((c) => c.choosed));
  target = (target.children ?? []).find((child) => child.choosed);
  const { loading, loadmore, onModelScroll, list, hasMore } = useScrollHandler(target, menuPath, modelType);

  if (loading) {
    return (
      <div className="flex flex-wrap">
        <CardShimmer ratio={ratio} cols={cols} />
      </div>
    );
  }
  const hasData = list.some(
    (li) =>
      (li?.type === innerMoreType.collect && li?.list?.length > 4) ||
      (li?.type === innerMoreType.children && li?.list?.length > 0),
  );
  if (!hasData) return <EmptyState />;

  if (list.length > 1) {
    return (
      <ScrollListener className="flex flex-wrap pl-4 pt-4 !h-auto" onScroll={() => onModelScroll()}>
        <InnerMore
          data={list[0] ?? []}
          ratio={ratio}
          cols={cols + 1}
          className="bg-[#F5F6FF] mb-4 mr-4 pt-4 pl-4 rounded-lg"
          {...props}
        />
        <div className="flex flex-wrap">
          {(list[1]?.list ?? []).map((item, idx) => {
            return modelType === modalType.WORKFLOW ? (
              <FlowCard data={item} key={idx} ratio={ratio} cols={cols} />
            ) : (
              <ModelCard data={item} key={idx} ratio={ratio} cols={cols} showTag={true} query={''} />
            );
          })}
        </div>
        {loadmore && <LoadMore />}
      </ScrollListener>
    );
  } else {
    return (
      <ScrollListener className="flex flex-wrap pl-4 !h-auto" onScroll={() => onModelScroll()}>
        {list[0].list.map((item, idx) => {
          return modelType === modalType.WORKFLOW ? (
            <FlowCard data={item} key={idx} ratio={ratio} cols={cols} />
          ) : (
            <ModelCard data={item} key={idx} ratio={ratio} cols={cols} showTag={true} query={''} onClick={applyModel} />
          );
        })}
        {loadmore && <LoadMore />}
        {!hasMore && (
          <div className="w-full">
            <Divider
              label={translate('history_bottom')}
              color="#EBEBEB"
              className="w-[40%] m-auto"
              styles={{ label: { fontSize: '12px', color: '#969696', lineHeight: '12px' } }}
            />
          </div>
        )}
      </ScrollListener>
    );
  }
};

export default L3Wrapper;
